/**
 * Design Center Notifications Bar
 * - This is a list of notifications that appears near the top of the design center.
 *   Each can be closed individually.
 */


/**
 * Bind actions / event listeners associated with notifications.
 * Close button removes notification item
 * @return  {void}
 */
const bindNotificationActions = async () => {
    // Handle event from the parent element
    const notificationEl = document.querySelector('.dc-notifications');
    if (notificationEl !== null) {
        notificationEl.addEventListener(
            'click',
            (ev) => {
                // Only remove element if the click was on the close button
                if (ev.target !== null && ev.target.classList.contains('close')) {
                    ev.target.parentElement.remove();
                }
            },
            false
        );
    }
};

/**
 * Remove any existing notification items from the DOM.
 * (Note: Parent element and template LI item remain)
 * @return  {void}
 */
export const clearNotifications = () => {
    document.querySelectorAll('.dc-notifications--item').forEach(el => el.remove());
}

/**
 * Add notification to the end of the list.
 * Clones hidden template LI item for markup, and changes out the text and classes.
 * @param   {string}  message  Notification text
 * @param   {array}  classes   Array of strings
 * @return  {void}
 */
export const addNotification = (message, classes) => {
    const notifElementTemplate = document.querySelector('#dc-notifications--template');
    let newElement = null;
    if (notifElementTemplate !== null){
        // Clone template element on page and remove ID
        newElement = notifElementTemplate.cloneNode(true);
        newElement.removeAttribute('id');
        // Add classes
        newElement.classList.add('dc-notifications--item');
        classes.forEach(c => {
            newElement.classList.add(c);
        });
        // Add text
        newElement.querySelector('.text').innerHTML = message;
        // Inject it into the DOM
        newElement.removeAttribute('style'); // remove display: none
        notifElementTemplate.before(newElement);
    }
}

export default bindNotificationActions;